import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { Injectable } from '@angular/core';
import { Test } from "../../common/models/test";
import { CurrentUser } from "../../common/providers/current-user";
import { OrganizationRole } from "../../common/models/organization-role";
import { Voter } from "../../common/security/voter";

@Injectable({providedIn: 'root'})
export class TestVoter extends Voter {
    public static readonly ADD: string = 'add';
    public static readonly EDIT: string = 'edit';
    public static readonly DELETE: string = 'delete';

    constructor(
        private currentUserRolesProvider: CurrentUserRolesProvider,
    ) {
        super();
    }

    protected supports(attribute: string, subject: any): boolean {
        return ([
            TestVoter.ADD,
            TestVoter.EDIT,
            TestVoter.DELETE,
        ].indexOf(attribute) !== -1) && subject instanceof Test;
    }

    protected voteOnAttribute(attribute: string, subject: any, currentUser: CurrentUser): boolean {
        if (!currentUser.hasOwnProperty('organization')) {
            return false;
        }

        /**
         * Admin can do everything
         */
        if (currentUser.user?.isAdmin) {
            return true;
        }

        const roles = this.currentUserRolesProvider.getRolesIds(currentUser.organization?.id!);

        /**
         * Tests can only be added by COACH
         */
        if (TestVoter.ADD === attribute) {
            return (roles.indexOf(OrganizationRole.ID_COACH) !== -1);
        }

        /**
         * Tests can only be added by COACH
         */
        if (TestVoter.EDIT === attribute) {
            return (roles.indexOf(OrganizationRole.ID_COACH) !== -1);
        }

        /**
         * Tests can only be added by COACH
         */
        if (TestVoter.DELETE === attribute) {
            return (roles.indexOf(OrganizationRole.ID_COACH) !== -1);
        }

        return false;
    }
}
